import { notReachable } from '@cast/utils';

type FeedbackVariant = 'like' | 'dislike' | 'bug';

export type Feedback =
  | {
      variant: Extract<FeedbackVariant, 'like'>;
    }
  | {
      variant: Extract<FeedbackVariant, 'dislike'>;
      reason: string;
      details?: string;
    }
  | {
      variant: Extract<FeedbackVariant, 'bug'>;
      details: string;
    };

export const BUG_REPORT_REASON = 'Technical issue / bug';

export const getFeedbackAnalyticsFields = (
  feedback: Feedback
): { reason?: string; details?: string } => {
  switch (feedback.variant) {
    case 'like':
      return {};
    case 'dislike':
      return { reason: feedback.reason, details: feedback.details };
    case 'bug':
      return { reason: BUG_REPORT_REASON, details: feedback.details };
    default:
      return notReachable(feedback);
  }
};
